// extracted by mini-css-extract-plugin
export default {"field":"TotalTasksField_field__p09Ro","active":"TotalTasksField_active__6dDIV","pastDue":"TotalTasksField_pastDue__leJPl"};